export default "__VITE_ASSET__maK7snZV__"